/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';
import { Currency } from './styles';

export interface INumberInputProps {
    id: string;
    fontScale?: number;

    label?: string;
    labelColor?: string;
    errorText?: string;
    disabled?: boolean;
    hasError?: boolean;
    groupText?: string;
    value?: string;
    required?: boolean;
    placeholder?: string;
    currency?: string;
    min?: number;
    max?: number;
    onCompChange?(id: string, payload: any): void;
}

export const NumberInput = ({
    id,
    fontScale,

    label,
    labelColor,
    errorText,
    hasError,
    groupText,
    value,
    required,
    disabled,
    placeholder,
    currency,
    min,
    max,
    onCompChange,
}: INumberInputProps) => {
    const [textValue, setTextValue] = useState(value + '' ?? '');
    const [isInvalid, setInvalid] = useState(false);
    useEffect(() => setTextValue(value ?? ''), [value]);

    console.log('34982758342795', value, min, textValue);
    useEffect(() => setTextValue(value), [value]);
    useEffect(() => {
        if (hasError) {
            setInvalid(true);
        }
        if (!hasError) {
            if (isInvalid) {
                setInvalid(false);
            }
        }
    }, [hasError]);

    const onChange = (id: string, e: any) => {
        // if (min && max) {
        //     if (e?.target?.value >= min && e?.target?.value <= max) {
        //         setTextValue(e?.target?.value);
        //         onCompChange && onCompChange(id, e?.target?.value);
        //     }
        // } else if (min) {
        //     if (e?.target?.value < min) {
        //         setTextValue(min);
        //         onCompChange && onCompChange(id, min);
        //     }
        //     if (e?.target?.value >= min) {
        //         setTextValue(e?.target?.value);
        //         onCompChange && onCompChange(id, e?.target?.value);
        //     }
        // } else if (max) {
        //     if (e?.target?.value <= max) {
        //         setTextValue(e?.target?.value);
        //         onCompChange && onCompChange(id, e?.target?.value);
        //     }
        // } else {
        setTextValue(e?.target?.value);
        onCompChange && onCompChange(id, e?.target?.value);
        // }
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    document.getElementById(`input-${id}`)?.addEventListener('focusin', (e) => {
        console.log(e, 'moi->');
        document
            .getElementById(`input-group-${id}`)
            ?.classList.add('input-group-ch');
    });
    document
        .getElementById(`input-${id}`)
        ?.addEventListener('focusout', (e) => {
            console.log(e, 'moi->');
            document
                .getElementById(`input-group-${id}`)
                ?.classList.remove('input-group-ch');
        });

    return (
        <>
            <Form.Group id={id} className=" formgroup">
                {_renderLabelIf()}
                <InputGroup id={`input-group-${id}`} className="input-group-bt">
                    {groupText && (
                        <InputGroup.Text id="basic-addon1">
                            {groupText}
                        </InputGroup.Text>
                    )}
                    <div className="d-flex">
                        {currency && <Currency>{currency}</Currency>}
                        <S.FormControl
                            fontScale={fontScale}
                            id={`input-${id}`}
                            className="formcontrol shadow-none"
                            value={textValue}
                            onChange={onChange.bind(null, id)}
                            required={required}
                            type="number"
                            min={0}
                            placeholder={placeholder}
                            disabled={disabled}
                            isInvalid={isInvalid}
                        />
                    </div>
                </InputGroup>
                <InputGroup>{_renderErrorTextIf()}</InputGroup>
            </Form.Group>
        </>
    );
};

NumberInput.defaultProps = {
    required: false,
    disabled: false,
    hasError: false,
};
